import { useTranslation } from 'react-i18next';
import { CaixaMarcar } from '../../componentes/agendamento-comum';

/**
 * Lista B de 30/10 (item 23), ficha 2026-11-03: na tarefa do tipo Reunião, a caixa "Agendar na Agenda e no Google" (marcada por
 * padrão). Marcada, a tarefa mostra os campos da reunião livre (`CamposReuniaoLivre`), sem serviço nem recurso; desmarcada, só
 * registra a atividade (reunião já feita ou marcada por fora).
 */
export function BlocoAgendaReuniao({ id, agendar, aoMudar }: { id: string; agendar: boolean; aoMudar: (agendar: boolean) => void }) {
  const { t } = useTranslation('pipeline');
  return (
    <div className="flex flex-col gap-3" data-agenda-reuniao="">
      <CaixaMarcar id={`${id}-agendar`} rotulo={t('crm.form.agendarNaAgenda')} ajuda={t('crm.form.agendarNaAgendaAjuda')} marcado={agendar} aoMudar={aoMudar} />
    </div>
  );
}
